import React from 'react';
import { Navigate } from 'react-router-dom';
 import GalmudugWeb from '../web/galmudug/Galmudug';
import KaafiPayWeb from '../web/KaafiPay/KaafiPay';
import { API_URL } from '../../constants/api';

function StartupRedirect() {
//   const allowedSubdomains = ['customer', 'portal', 'student', 'elearn'];
  const pathName = window.location.href;
  const hostname = window.location.hostname; // e.g., 'customer.example.com'
  const parts = hostname.split('.'); // e.g., ['customer', 'example', 'com']

  if (parts.length <= 2) {
    // Example: localhost or example.com
    if (API_URL.includes('galmudug') || API_URL.includes('hirshabeele')) {
      return <GalmudugWeb />;
    }
    return <KaafiPayWeb />;
  }

  const subdomain = parts[0];

  if (['customer', 'portal', 'student'].includes(subdomain)) {
    return <Navigate to={`/login/${subdomain}-login`} replace />;
  }

  if (subdomain === 'elearn') {
    return <Navigate to="/elearningHome" replace />;
  }

  if (pathName.includes('https://newktc.kaafi.net/Certificate/')) {
    window.location.href = pathName; // full redirect
    return null;
  }

  if (pathName.includes('https://portal.kaafi.net')) {
    return <Navigate to="/login/portal-login" replace />;
  }

  return <Navigate to="/login/user-login" replace />;
}

export default StartupRedirect;